import { styled } from '@mui/system'

export const OverviewItemContainer = styled('div')`
    display: grid;
    grid-template-rows: 1fr 1fr;
    row-gap: 16px;
    padding: 20px;
`

export const ContentContainer = styled('div')`
    display: flex;
    flex-direction: column;
`
